// import NewOfferingButton, {EditOfferingButton, DeleteOfferingButton} from 'components/NewOfferingButton';
import NewCouponButton, { EditCouponButton, DeleteCouponButton } from 'components/coupons/NewCouponButton';
import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import ReactTable from 'react-table';
import { Route, Switch, useLocation, useHistory } from "util/router.js";
import { loadCoupons } from 'store/actions/couponActions'
import { loadOfferings } from 'store/actions/offeringsActions'
import { Helmet } from 'react-helmet'
import ShareButton from 'components/ShareButton'
import OfferingSection from 'components/OfferingSection';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Section from 'components/Section'
import moment from 'moment-timezone'
import BackButton from 'components/BackButton';
import { apiRequest } from 'util/api/util';
import UserButton from 'components/CustomButtons/UserButton'
import { useAuth } from "util/auth.js";
import ReactDOM from 'react-dom'
import Button from "components/CustomButtons/Button.js";
import {CSVLink, CSVDownload} from 'react-csv';

const BASE_URL = process.env.REACT_APP_BOOKING_SUCCESS_URL

function SubmissionsTable(props) {

    const { formId } = props
    const auth = useAuth();

    const location = useLocation();

    const [response, setResponse] = React.useState(null)
    const [submissions, setSubmissions] = React.useState([])
    const [isLoading, setIsLoading] = React.useState(false)

    useEffect(() => {

        if (!auth.user) {
            return
        }
        setIsLoading(true)

        apiRequest('app/forms/getFormSubmissions', "POST", {
            formId: formId
        })
            .then(response => {

                setSubmissions(response)
                console.log("Submissions: ", response)

                setIsLoading(false)
            })
            .catch(val => {
                setIsLoading(false)
                console.log(val)
            })

    }, [formId, auth.user])

    // const coupons = useSelector(state => state.instructor.coupons);
    //   const widgetName = useSelector(state => state.instructor.instructor.widgetName)
    //   const currency = useSelector(state => state.instructor.instructor?.instructorProfile?.currency ?? "USD")
    //   const currencyFormatter = new Intl.NumberFormat('en-US', {
    //     style: 'currency',
    //     currency: currency,
    //   });

    let questions = {}

    const tableData = submissions.map(val => {

        let dataMap = {}

        if (val.user) {
            dataMap.user = val.user
        }

        if (val.response) {

            val.response.forEach((thingy, index) => {
                if (thingy.question && thingy.answer) {
                    let question = `${index + 1}_${thingy.question}`
                    dataMap[question] = thingy.answer
                    if (!questions[question]) {
                        questions[question] = true
                    }
                }
            })
        }


        return dataMap
    })

    const questionColumns = Object.keys(questions).map(val => {
        return {
            Header: val,
            accessor: val,
            minWidth: 100,
            filterable: false
        }
    })


    //   submissions.map(val => {

    //     // const user = 

    //     return {
    //       ...val,
    //       discount_amount: currencyFormatter.format(val?.discount_amount)
    //     }
    //   })

    const tableColumns = [
        {
            Header: "Name",
            accessor: "user",
            // sort: "desc"
            sortable: true,
            sortMethod: (a, b) => a.firstName > b.firstName ? 1 : -1,
            Cell: row => (
                <UserButton
                    user={row.value}
                />
            ),
        },
        ...questionColumns
    ]

    function handleExport() {
        let headers = tableColumns.map(val => {
            if (val.Header !== 'Name') {
                return {
                    label: val.Header, 
                    key: val.Header
                }
            }
        }).filter(val => {
            return val
        })
        headers = [
            ...headers,
            ...[
                {label: 'username', key: 'username'},
                {label: 'email', key: 'email'}
            ]
        ]
        const cleanedData = tableData.map(val => {
            const username = (val?.user?.firstName ?? "") + " " + (val?.user?.lastName ?? "")
            const email = val?.user?.email ?? "unknown-email"
            delete val.user
            return {
                username: username,
                email: email,
                ...val
            }
        })

        console.log("CLEAN DATA: ", cleanedData)
        console.log("CLEAN HEADEr: ", headers)
        const element = (<CSVDownload filename={`form-export.csv`} data={cleanedData} headers={headers} target="_blank" />);
 
        ReactDOM.render(element, document.querySelector('#export-forms-div'));
    }

    return (
        <div>
            <div className="d-flex flex-row-reverse">
                <Button onClick={handleExport} size={"sm"}>Export to CSV</Button>
                <div id='export-forms-div'></div>
            </div>
            <ReactTable
                loading={isLoading}
                data={tableData}
                filterable={true}
                columns={tableColumns}
                defaultPageSize={10}
                showPaginationTop={false}
                showPaginationBottom={true}
                className="-highlight"
            />
        </div>
    )
}


function SubmissionsPage(props) {

    const formId = props.match.params.formId
    // const dispatch = useDispatch();
    // const partnerId = useSelector(state => state.instructor.instructor.platformID);
    const partner = useSelector(state => state.instructor.instructor);
    // const coupon = useSelector(state => state.instructor.coupons.find(val => val.id === couponId));
    // useEffect(() => {
    //     // dispatch
    //     if (partnerId) {
    //     // dispatch(loadOfferings())
    //     // dispatch(loadCoupons())
    //     }

    // }, [dispatch, partnerId]);


    const shareLink = "https://sutrapro.com/" + (partner?.widgetName ?? "") + "/gifting"
    return (<>

        <Helmet>
            <title>Form Submissions</title>
        </Helmet>
        <div className="container px-0 "  >
            <BackButton />
            <section>
                <SubmissionsTable
                    {...props}
                    formId={formId}
                />
            </section>
        </div>
    </>
    );

}

export default SubmissionsPage;
